import O1HD from "../../../../engines/gameEngine";
import coin from "../../../../O1ModuleRes/control/coin";
import spendMode from "../../spendMode";
import weChatPrefab from "../weChatPrefab/weChatPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BeFatherChallege extends cc.Component {

    @property({type:cc.Node,displayName:"聊天content"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"自己说话节点"})
    meTalkPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"对方说话预制体"})
    sideTalkPrefab:cc.Prefab = null;

    @property({type:cc.ScrollView,displayName:"scrollView"})
    scrollView:cc.ScrollView = null;

    onLoad(){
        this.sideTalk();
    }

    subMoney:number = 0;

    moneyArr:number[] = [
        null,
        5200,
        10000,
        100000,
        200000,
        1000000
    ];

    sideChat:string[][] = [
        ["真的给叫，你就给我钱吗?"],
        ["好的，爸爸，刚刚有个人说给钱让我做他女朋友，我说不要，我要好好学习，我爸爸会给我！"],
        ["俗话说得好！女儿养的好，以后华子少不了！爸爸给钱！"],
        ["一万两万刚刚好，十万八万刚刚好，我永远是贴心小棉袄！"],
        ["爸，你闺女没钱了","那我找个有钱的呗"],
        ["我同学好像在按摩店看到你了"]
    ]

    meChat:string[] = [
        "真的，不过你要说出让我给你钱的理由",
        "转钱",
        "转钱",
        "这小嘴真甜",
        "拿去花",
        "你别瞎说！这钱转你，别污蔑我！"
    ]

    async sideTalk(){
        let chats:string[] = this.sideChat[this.round];
        for(let i =0;i<chats.length;i++){
            let talkPrefab:cc.Node = cc.instantiate(this.sideTalkPrefab);
            let ts = talkPrefab.getComponent(weChatPrefab);
            ts.setChat(chats[i]);
            this.itemContent.addChild(talkPrefab);
            this.scrollView.scrollToBottom(0.2);
            await new Promise<void>(resolve=>{
                this.scheduleOnce(()=>{
                    resolve();
                },.5);
            });
        }
        this.updateChoose();
        this.showChoose();
    }

    @property({type:cc.Node,displayName:"chooseItem"})
    chooseNode:cc.Node = null;

    againCount:number = 0;
    maxAgainCount:number = 3;

    round:number = 0;

    updateChoose(){
        let choose:string = this.meChat[this.round];
        let chooses:string[] = [];
        if(this.round ==0){
            chooses = [choose];
        }else{
            chooses = [choose,"重来"];
        }
        this.chooseNode.children.forEach((n:cc.Node,index:number)=>{
            let lb:cc.Label = n.getChildByName("lb").getComponent(cc.Label);
            if(chooses[index]){
                lb.string = chooses[index];
                n.active = true;
            }else{
                n.active = false;
            }
        });
    }

    showChoose(){
        this.chooseNode.active = true;
    }

    hideChoose(){
        this.chooseNode.active = false;
    }

    async onBtnChoose(e:cc.Event.EventTouch,custom:string){
        let roundMoney:number = this.moneyArr[this.round];
        let choose:string = this.meChat[this.round];
        let chooses:string[] = [choose,"重来"];
        let index:number = Number(custom);
        let isAgain:boolean = false;
        this.hideChoose();
        if(index == 0){
            if(roundMoney != null){    
                this.subMoney += roundMoney;
                spendMode._instance.manage.setGameData({_coin:-roundMoney},true,e.target);
            }
            let meTalkPrefab:cc.Node = cc.instantiate(this.meTalkPrefab);
            let ms = meTalkPrefab.getComponent(weChatPrefab);
            if(chooses[index] == "转钱"){
                ms.setTransfer(roundMoney);
                this.itemContent.addChild(meTalkPrefab);
            }else{
                ms.setChat(chooses[index]);
                this.itemContent.addChild(meTalkPrefab);
                this.scrollView.scrollToBottom(0.2);
                if(roundMoney != null){
                    await new Promise<void>(resolve=>{
                        this.scheduleOnce(()=>{
                            let n = cc.instantiate(this.meTalkPrefab);
                            let ns = n.getComponent(weChatPrefab);
                            ns.setTransfer(roundMoney);
                            this.itemContent.addChild(n);
                            resolve();
                        },.5);
                    });
                }
            }
        }else{
            isAgain = true;
            this.againCount ++;
            let meTalkPrefab:cc.Node = cc.instantiate(this.meTalkPrefab);
            let ms = meTalkPrefab.getComponent(weChatPrefab);
            ms.setChat(chooses[index]);
            this.itemContent.addChild(meTalkPrefab);
        }
        this.scrollView.scrollToBottom(0.2);
        if(this.againCount >= this.maxAgainCount){
            // 游戏结束  触发嫌弃太麻烦事件
            console.log("嫌弃太麻烦");
            this.hideChoose();
            this.scheduleOnce(()=>{
                let oChat:cc.Node = cc.instantiate(this.sideTalkPrefab);
                let os = oChat.getComponent(weChatPrefab);
                os.setChat("你这人怎么这么难搞定啊！我不玩了！");
                this.itemContent.addChild(oChat);
                this.scrollView.scrollToBottom(0.2);
                this.scheduleOnce(()=>{
                    this.node.destroy();
                    this.node.removeFromParent();
                },2);
            },1);
            return;
        }
        this.round ++;
        if(this.round >= this.meChat.length){
            // 整个事件结束
            if(isAgain){
                //  触发返还的钱
                console.log("不返钱");
                O1HD.getModules().uiControlModule.showDialogBox("事件结果",`本次事件共花费${this.subMoney}元`,false);
                this.node.destroy();
                this.node.removeFromParent();
            }else{
                // 关闭
                console.log("返钱");
                O1HD.getModules().uiControlModule.showDialogBox("事件结果","在无限的对话中，对方被你的壕无人性打动，将所有钱还给了你",false,(isok=>{
                    if(isok){
                        spendMode._instance.manage.setGameData({_coin:this.subMoney},true,e.target);
                    }
                }));
                this.node.destroy();
                this.node.removeFromParent();
            }
        }else{
            this.scheduleOnce(()=>{
                this.sideTalk();
            },1);
        }
    }

}
